import { ICustomer } from "../common/data/dtos/customer";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/Customer';

interface CustomerResponse {
    success: boolean;
    customer?: ICustomer;
    customers?: ICustomer[];
    error?: string;
}

type CreateCustomerType = Omit<ICustomer, 'id'> | Partial<ICustomer>;

const createCustomer = async (customer: CreateCustomerType): Promise<CustomerResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<ICustomer>(`${BASE_PATH}`, customer);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getCustomers = async (): Promise<CustomerResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<ICustomer>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, customers: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteCustomer = async (id: string): Promise<CustomerResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<ICustomer>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateCustomer = async (customer: ICustomer): Promise<CustomerResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<ICustomer>(`${BASE_PATH}/${customer.id}`, customer);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    getCustomers,
    deleteCustomer,
    updateCustomer,
    createCustomer,
};